<template>
  <button
    class="p-2 mb-4 ml-6 font-bold text-white rounded-full tmsk-blue-bg focus:outline-none"
    @click="goBack"
  >
    <svg
      class="w-4 h-4"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path d="M15 19l-7-7 7-7"></path>
    </svg>
  </button>
</template>

<script>
export default {
  name: 'BackButton',
  components: {},
  mixins: [],
  props: {
    destination: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},

  // Lifecycle Hooks
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    goBack () {
      if (this.destination) this.$router.push({ name: this.destination, query: this.$route.query })
      else this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
</style>
